export default "__VITE_ASSET__BR0E5IrS__"